var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "container flex items-center justify-between mx-auto h-full px-1_5"
    },
    [
      _c("hamburger", {
        on: {
          "open-menu": function($event) {
            return _vm.$emit("open-menu")
          }
        }
      }),
      _vm._t("default"),
      _c("login", {
        attrs: {
          "user-logged-in": _vm.userLoggedIn,
          "cart-qty": _vm.cartQty,
          "is-whitelabel": _vm.isWhitelabel,
          cart: _vm.cart
        },
        on: {
          "log-out": function($event) {
            return _vm.$emit("log-out")
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }